import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Menu, MenuItem } from '@mui/material';

type CellContextMenuProps = {
  container: HTMLDivElement | null;
};

export const CellContextMenu: FC<CellContextMenuProps> = ({ container }) => {
  const [anchorPosition, setAnchorPosition] = useState<{ top: number; left: number } | null>(null);
  const cellValueRef = useRef<string>('');

  const handleContextMenu = useCallback((e: MouseEvent) => {
    const cell = (e.target as HTMLElement).closest('.MuiDataGrid-cell');
    if (!cell) return;

    e.preventDefault();
    const cellContent = cell.textContent ?? '';
    cellValueRef.current = cellContent;
    setAnchorPosition({ top: e.clientY, left: e.clientX });
  }, []);

  const handleClose = useCallback(() => {
    setAnchorPosition(null);
  }, []);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(cellValueRef.current);
      setAnchorPosition(null);
    } catch {
      setAnchorPosition(null);
    }
  }, []);

  useEffect(() => {
    if (!container) return;

    container.addEventListener('contextmenu', handleContextMenu);
    return () => {
      container.removeEventListener('contextmenu', handleContextMenu);
    };
  }, [container, handleContextMenu]);

  return (
    <Menu
      open={anchorPosition !== null}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition ?? undefined}
      slotProps={{ paper: { sx: { minWidth: 120 } } }}>
      <MenuItem onClick={handleCopy} sx={{ fontSize: 13 }}>
        Copy value
      </MenuItem>
    </Menu>
  );
};
